import { render, staticRenderFns } from "./EditItemPage.vue?vue&type=template&id=9d55a646&scoped=true"
import script from "./EditItemPage.vue?vue&type=script&lang=js"
export * from "./EditItemPage.vue?vue&type=script&lang=js"
import style0 from "./EditItemPage.vue?vue&type=style&index=0&id=9d55a646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d55a646",
  null
  
)

export default component.exports